import { api } from "../../../../helper/api";
import { mConstants } from "../../../../helper/constants";
import { AddressEntity, Entity, EntityOption } from "../shared.model";

function getBrands(): Promise<Entity[]> {
  return api.get(`${mConstants.ORDER_URL}/entities/brands`);
}

function getCategories(): Promise<Entity[]> {
  return api.get(`${mConstants.ORDER_URL}/entities/categories`);
}

function getRoutes(): Promise<EntityOption[]> {
  return api.get(`${mConstants.ORDER_URL}/entities/categories/route`);
}

function getChannels(): Promise<EntityOption[]> {
  return api.get(`${mConstants.ORDER_URL}/entities/categories/channel`);
}

function getCities(): Promise<AddressEntity[]> {
  return api.get(`${mConstants.DICTIONARY_URL}/dictionary/cities`);
}

function getDistrict(): Promise<AddressEntity[]> {
  return api.get(`${mConstants.DICTIONARY_URL}/dictionary/districts`);
}

function getKhoroos(): Promise<AddressEntity[]> {
  return api.get(`${mConstants.DICTIONARY_URL}/dictionary/khoroos`);
}

export const entityService = {
  getBrands,
  getCategories,
  getRoutes,
  getCities,
  getDistrict,
  getKhoroos,
  getChannels,
};
